<div class="page-container fade-in-up">
    <!-- Header -->
    <div class="page-header">
        <div class="header-content">
            <!-- Breadcrumb removed, handled globally -->
            <a class="go-back-btn" (click)="goBack()">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                Go Back
            </a>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content" *ngIf="orderData">
        <div class="content-wrapper">

            <!-- LEFT SIDEBAR - ORDER CARD -->
            <div class="order-card">
                <div class="order-icon-wrapper">
                    <div class="order-icon" [class.pickup]="orderData?.order_type === 'pickup' && driverAssigned"
                        [class.delivery]="orderData?.order_type === 'delivery' && driverAssigned"
                        [class.warehouse]="orderData?.order_type === 'warehouse' && driverAssigned">

                        <!-- ===== DELIVERY ICONS ===== -->
                        <ng-container *ngIf="orderData.order_type === 'delivery'">
                            <!-- Assigned Delivery -->
                            <div *ngIf="driverAssigned">D</div>

                            <!-- Unassigned Delivery -->
                            <svg *ngIf="!driverAssigned" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="none" style="width: 48px; height: 48px;">
                                <rect x="2" y="2" width="20" height="20" rx="4" stroke="#008A51" stroke-width="1"
                                    fill="none" />
                                <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100" fill="#008A51"
                                    font-family="Arial, sans-serif">D</text>
                            </svg>
                        </ng-container>

                        <!-- ===== PICKUP ICONS ===== -->
                        <ng-container *ngIf="orderData.order_type === 'pickup'">
                            <!-- Assigned Pickup -->
                            <div *ngIf="driverAssigned">P</div>

                            <!-- Unassigned Pickup -->
                            <svg *ngIf="!driverAssigned" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="none" style="width: 48px; height: 48px;">
                                <rect x="2" y="2" width="20" height="20" rx="4" stroke="#DB2777" stroke-width="1"
                                    fill="none" />
                                <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100" fill="#DB2777"
                                    font-family="Arial, sans-serif">P</text>
                            </svg>
                        </ng-container>

                        <!-- ===== WAREHOUSE ICONS ===== -->
                        <ng-container *ngIf="orderData.order_type === 'warehouse'">
                            <!-- Assigned Warehouse -->
                            <div *ngIf="driverAssigned">W</div>

                            <!-- Unassigned Warehouse -->
                            <svg *ngIf="!driverAssigned" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="none" style="width: 48px; height: 48px;">
                                <rect x="2" y="2" width="20" height="20" rx="4" stroke="#1e40af" stroke-width="1"
                                    fill="none" />
                                <text x="12" y="17" text-anchor="middle" font-size="13" font-weight="100" fill="#1e40af"
                                    font-family="Arial, sans-serif">W</text>
                            </svg>
                        </ng-container>
                    </div>
                </div>

                <div class="order-number">
                    <div *ngIf="orderData?.order_type === 'pickup'" class="DeliveryNumber">
                        <h4>{{ orderData?.po || 'N/A' }}</h4>
                        <p class="fontSize10">
                            Committed Time: {{ getFormattedTime1() || 'N/A' }} | {{
                            convertToLocalDate(orderData?.pickup_date) }}
                        </p>
                    </div>
                    <div *ngIf="orderData?.order_type === 'delivery'" class="DeliveryNumber">
                        <h4>{{ orderData?.order_no || 'N/A' }}</h4>
                        <p class="fontSize10">
                            Committed Time: {{ getFormattedTime() || 'N/A' }} | {{
                            convertToLocalDate(orderData?.dely_date) }}
                        </p>
                    </div>
                </div>

                <!-- Map Placeholder -->
                <div class="order-map" *ngIf="mapEmbedUrl">
                    <iframe
                        [src]="mapEmbedUrl"
                        loading="lazy"></iframe>
                    <div class="map-overlay">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                                clip-rule="evenodd" />
                        </svg>
                        {{ orderData?.order_type === 'pickup' ? 'Pickup Location' : (orderData?.order_type === 'warehouse' ? 'Warehouse Location' : 'Delivery Location') }}
                    </div>
                </div>

                <button class="track-button"
                    [ngClass]="{'disabled-custom': orderStatus !== 'en-route' && orderStatus !== 'arrived'}"
                    (click)="trackOrder()">
                    <span class="track-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                        </svg>
                    </span>
                    Track Order
                </button>

                <!-- Packing Slip -->
                <!-- <div class="upload-section">
                    <label class="upload-label">Packing Slip</label>
                    <div class="upload-placeholder" [class.has-image]="uploadedImageUrl" (click)="uploadPackingSlip()">
                        <img [src]="uploadedImageUrl" *ngIf="uploadedImageUrl" class="upload-preview">
                        <ng-container *ngIf="!uploadedImageUrl">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0z" />
                            </svg>
                            <p>No Slip Uploaded</p>
                        </ng-container>
                    </div>
                </div> -->
            </div>

            <!-- RIGHT CONTENT AREA -->
            <div class="details-content">
                <!-- ACTION BUTTONS -->
                <div class="action-section">
                    <div class="action-buttons">
                        <button class="action-btn btn-notifications" (click)="openNotifications()">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                                <path fill-rule="evenodd"
                                    d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                                    clip-rule="evenodd" />
                            </svg>
                            Notifications
                        </button>
                    </div>
                </div>

                <!-- STATUS PROGRESS -->
                <div class="status-section">
                    <h3 class="status-header">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0118 0z" />
                        </svg>
                        Order Status Timeline
                    </h3>

                    <div class="status-progress">
                        <div class="status-line">
                            <div class="status-line-progress"></div>
                            <div class="status-truck" [style.left.%]="truckPosition">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                    <path
                                        d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 00.75-.75V15z" />
                                    <path
                                        d="M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zM15.75 6.75a.75.75 0 0 0-.75.75v11.25c0 .087.015.17.042.248a3 3 0 0 1 5.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75z" />
                                    <path d="M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                </svg>
                            </div>
                        </div>

                        <div class="status-step" *ngFor="let step of statusSteps" [class.completed]="step.completed"
                            [class.active]="step.active" [class.current]="step.isCurrent"
                            [class.unsuccessful]="step.key === 'unsuccessful'"
                            [class.cancelled]="step.key === 'cancelled'">
                            <div class="status-icon-wrapper">
                                <ng-container [ngSwitch]="step.icon">
                                    <svg *ngSwitchCase="'clipboard-check'" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M7.502 6h7.128A3.375 3.375 0 0118 9.375v9.375a3 3 0 003-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 00-.673-.05A3 3 0 0015 1.5h-1.5a3 3 0 00-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6zM13.5 3A1.5 1.5 0 0012 4.5h4.5A1.5 1.5 0 0015 3h-1.5z"
                                            clip-rule="evenodd" />
                                        <path fill-rule="evenodd"
                                            d="M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V9.375zm9.586 4.594a.75.75 0 00-1.172-.938l-2.476 3.096-.908-.907a.75.75 0 00-1.06 1.06l1.5 1.5a.75.75 0 001.116-.062l3-3.75z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    <svg *ngSwitchCase="'cube'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                        fill="currentColor">
                                        <path
                                            d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z" />
                                        <path fill-rule="evenodd"
                                            d="M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zM12 10.5a.75.75 0 01.75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 01.75-.75z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    <svg *ngSwitchCase="'truck'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                        fill="currentColor">
                                        <path
                                            d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 00.75-.75V15z" />
                                        <path
                                            d="M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zM15.75 6.75a.75.75 0 00-.75.75v11.25c0 .087.015.17.042.248a3 3 0 015.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75z" />
                                        <path d="M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                    </svg>
                                    <svg *ngSwitchCase="'map-pin'" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    <svg *ngSwitchCase="'check-circle'" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </ng-container>
                            </div>
                            <div class="status-label">{{ step.label }}</div>
                            <div class="status-time" *ngIf="step.time">{{ step.time }}</div>
                        </div>
                    </div>
                </div>

                <!-- ORDER INFORMATION -->
                <div class="info-section">
                    <div class="info-section-header">
                        <h3 class="info-section-title">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9z" />
                            </svg>
                            Order Details
                        </h3>
                        <span class="status-badge" [ngClass]="getStatusClass(orderStatus)">{{ orderStatus | titlecase
                            }}</span>
                    </div>

                    <div class="info-cards-grid">
                        <div class="info-card highlight">
                            <div class="info-card-label">Order Number</div>
                            <div class="info-card-value">{{ orderData.order_no || orderData.po || 'N/A' }}</div>
                        </div>
                        <div class="info-card">
                            <div class="info-card-label">Customer</div>
                            <div class="info-card-value">{{ orderData.customer_name || 'N/A' }}</div>
                        </div>
                        <div class="info-card">
                            <div class="info-card-label">Order Date</div>
                            <div class="info-card-value">{{ convertToLocalDate(orderData.created_at) }}</div>
                        </div>
                        <div class="info-card">
                            <div class="info-card-label">Delivery Date</div>
                            <div class="info-card-value">{{ convertToLocalDate(orderData.dely_date) }}</div>
                        </div>
                        <div class="info-card">
                            <div class="info-card-label">Address</div>
                            <div class="info-card-value">{{ orderData.customer_addr || 'N/A' }}</div>
                        </div>
                        <div class="info-card">
                            <div class="info-card-label">Phone</div>
                            <div class="info-card-value">{{ orderData.customer_phone || 'N/A' }}</div>
                        </div>
                    </div>
                </div>

                <!-- DRIVER INFO -->
                <div class="driver-section" *ngIf="driverAssigned">
                    <h3 class="section-title">Assigned Driver</h3>
                    <div class="driver-assignment">
                        <div class="driver-avatar">
                            <img *ngIf="orderData.current_driver?.profile_image"
                                [src]="orderData.current_driver.profile_image">
                            <span *ngIf="!orderData.current_driver?.profile_image">{{
                                getDriverInitials(orderData.current_driver) }}</span>
                        </div>
                        <div class="driver-details">
                            <div class="driver-name">{{ orderData.current_driver?.first_name }} {{
                                orderData.current_driver?.last_name }}</div>
                            <div class="driver-phone">{{ orderData.current_driver?.phone_number }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-overlay" [class.active]="isNotificationPanelOpen" (click)="closeNotifications()">
  <div class="notification-panel" [class.active]="isNotificationPanelOpen" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-top">
        <h2 class="panel-title">Recent Notifications</h2>
        <button class="close-btn" (click)="closeNotifications()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="tabs-container">
        <button class="tab" [class.active]="activeTab === 'customer'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          </svg>
          Company
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="panel-content">
      <!-- View All Button -->
      <div class="view-all-section">
        <button class="view-all-btn-top" (click)="viewAllNotifications()" [disabled]="
    (activeTab === 'customer' && (!orderDetailRn || orderDetailRn.length === 0)) ||
    (activeTab === 'driver' && (!orderDetailRnD || orderDetailRnD.length === 0))
  ">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
          View All {{ activeTab === 'companies' ? 'Company' : 'Company' }} Notifications
        </button>
      </div>

      <div *ngIf="activeTab == 'customer'" class="notification-list">
        <div class="notification-item" *ngFor="let notification of orderDetailRn"
          [class.has-image]="notification.images.length > 0">
          <div class="notification-item-top" *ngIf="notification.images.length > 0; else normalLayout">
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
            <img [src]="notification.images[0].image_url" alt="Notification image" class="notification-image">
          </div>

          <ng-template #normalLayout>
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
          </ng-template>
        </div>
        <div *ngIf="!orderDetailRn || orderDetailRn.length === 0 && activeTab == 'customer'" class="mt-4 PacelId">
          No Recent Notification
        </div>
      </div>
      <div *ngIf="activeTab == 'driver'" class="notification-list">
        <div class="notification-item" *ngFor="let notification of orderDetailRnD"
          [class.has-image]="notification.image.length > 0">
          <div class="notification-item-top" *ngIf="notification.image.length > 0; else normalLayout">
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
            <img [src]="notification.image[0].image_url" alt="Notification image" class="notification-image">
          </div>

          <ng-template #normalLayout>
            <div class="notification-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z" />
                <path fill-rule="evenodd"
                  d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="notification-content">
              <div class="notification-message">{{ notification.notification }}</div>
              <div class="notification-time">{{ notification.when_sent }}</div>
            </div>
            <div class="unread-badge" *ngIf="notification.isUnread"></div>
          </ng-template>
        </div>
      </div>
      <div *ngIf="!orderDetailRnD || orderDetailRnD.length === 0 && activeTab == 'driver'" class="mt-4 PacelId">
        No Recent Notification
      </div>
    </div>
  </div>
</div>